"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function mapToDisclaimerProps({ data, inline }) {
    let disclaimer = null;
    let raw = null;
    if (!('blockType' in data)) {
        disclaimer = data;
    }
    else if (data.disclaimerReference &&
        typeof data.disclaimerReference === 'object') {
        disclaimer = data.disclaimerReference;
        raw = disclaimer?.brandyRaw ?? null;
    }
    return {
        variant: 'legal',
        rendersAs: inline ? 'span' : null,
        disclaimer: raw,
    };
}
exports.default = mapToDisclaimerProps;
